// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1IPAccessControlDefault = {
  IPAccessControlDefaultDenyAll: 'DENY_ALL',
  IPAccessControlDefaultAllowAll: 'ALLOW_ALL',
} as const;
export type V1IPAccessControlDefault =
  (typeof V1IPAccessControlDefault)[keyof typeof V1IPAccessControlDefault];

export function instanceOfV1IPAccessControlDefault(value: any): boolean {
  for (const key in V1IPAccessControlDefault) {
    if (Object.prototype.hasOwnProperty.call(V1IPAccessControlDefault, key)) {
      if (
        V1IPAccessControlDefault[
          key as keyof typeof V1IPAccessControlDefault
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1IPAccessControlDefaultFromJSON(
  json: any,
): V1IPAccessControlDefault {
  return V1IPAccessControlDefaultFromJSONTyped(json, false);
}

export function V1IPAccessControlDefaultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1IPAccessControlDefault {
  return json as V1IPAccessControlDefault;
}

export function V1IPAccessControlDefaultToJSON(
  value?: V1IPAccessControlDefault | null,
): any {
  return value as any;
}

export function V1IPAccessControlDefaultToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1IPAccessControlDefault {
  return value as V1IPAccessControlDefault;
}
